import React, { useEffect, useState } from "react";
import { BreadCrumbSecttion } from "../component/BreadCrumbSecttion";
import OtherService from "../services/Other";
import { Accordion, Col, Container, Row } from "react-bootstrap";
import Loader from "../component/Loader";
import { ChevronUp } from "react-feather";
import { ChevronDown } from "react-feather";
import useScrollToTop from "../hooks/useScrollToTop";
import DOMPurify from "dompurify";
import { parseSafeHtml } from "../utils/safeHtmlParser";

const FAQs = () => {
  useScrollToTop()
  const [isFaqData, setIsFaqData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isNoData, setIsNoData] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  useEffect(() => {
    const faqDataFetch = async () => {
      try {
        const token = localStorage.getItem("access_token");
        const responseFAQ = await OtherService.faqContent(token);
        if (
          responseFAQ.error == false &&
          responseFAQ.data.content_banner_details_contact.content_spot_contents
            .length > 0
        ) {
          setIsFaqData(
            responseFAQ.data.content_banner_details_contact
              .content_spot_contents
          );
          setLoading(false);
          setIsNoData(false);
        } else {
          setLoading(false);
          setIsNoData(true);
        }
      } catch (e) {
        console.error("error");
      }
    };
    faqDataFetch();
  }, []);
  const handleAccordion = (id) => {
    setSelectedId((prevSelectedId) => (prevSelectedId === id ? null : id));
  };
  return (
    <>
      {loading && <Loader />}

      <BreadCrumbSecttion pageTitle="FAQs" currentPageName="FAQs" />
      <section className="padTop50">
        {isNoData && <div className="noDataMsg">No data found!</div>}
        {!isNoData && (
          <div className="dashboard-details">
            <Container>
              <Row>
                <Col xs={12}>
                  <section className="padTop50">
                    <div className="userInfoBox bg-white">
                      {isFaqData.map((item, index) => {
                        const { content_map_id, article_detail, article_text } =
                          item;
                          
                        return (
                          <Accordion defaultActiveKey="0" className="mb-3" key={content_map_id}>
                            <Accordion.Item eventKey={index} key={index}>
                              <Accordion.Header>
                                <div className="col-6">
                                  <b className="text-primary">{DOMPurify.sanitize(article_text)}</b>
                                </div>
                              </Accordion.Header>
                              <Accordion.Body>
                              {/* <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(article_detail) }} className='mb-4 faqParagraphBox'> */}
                              <div>
                                  {parseSafeHtml(article_detail)}
                              </div>

                             {/* </div> */}
                              </Accordion.Body>
                            </Accordion.Item>
                          </Accordion>
                        );
                      })}
                    </div>
                  </section>
                </Col>
              </Row>
            </Container>
          </div>
        )}
      </section>
    </>
  );
};

export default FAQs;
